import axios from 'axios';
import { PubSubService } from '../_shared/pubSubServiceInterface';

class UserAuthenticationService extends PubSubService {
  public static readonly EVENTS = {
    USER_AUTHENTICATED: 'event::userAuthenticated',
    USER_UNAUTHENTICATED: 'event::userUnauthenticated',
  };

  public static REGISTRATION = {
    name: 'userAuthenticationService',
    altName: 'UserAuthenticationService',
    create: ({ configuration = {} }) => {
      return new UserAuthenticationService();
    },
  };

  private apiBaseUrl: string = window.location.origin + '/api'; // Set directly from window.location.origin
  // public apiBaseUrl: string = 'http://192.168.1.208:3001/api'; // Set directly from window.location.origin

  private isAuthenticated: boolean = false;
  public userInfo: any = localStorage.getItem('user') || null;
  public CWLList: Array<{ description: string; window: string; level: string }> = [];
  public dataStudy: any = null;
  public dataStudyQC: [] = [];
  // private userInfo: any = localStorage.getItem('user');
  private accessToken: string | null = localStorage.getItem('access_token') || null;

  serviceImplementation = {
    _getState: () => console.warn('getState() NOT IMPLEMENTED'),
    _setUser: () => console.warn('_setUser() NOT IMPLEMENTED'),
    _setStudyQC: study => this.setStudyQC(study),
    // _getUser: () => console.warn('_getUser() NOT IMPLEMENTED'),
    _getUser: () => this.getUser(),
    _getAuthorizationHeader: () => {}, // TODO: Implement this method
    _handleUnauthenticated: () => console.warn('_handleUnauthenticated() NOT IMPLEMENTED'),
    _reset: () => console.warn('reset() NOT IMPLEMENTED'),
    _set: () => console.warn('set() NOT IMPLEMENTED'),
    _validateToken: () => this.validateToken(),
    _getWindowLevel: () => this.getWindowLevel(),
    _getStudy: (accessionNumber: string) => this.getStudy(accessionNumber),
    _getDataStudy: () => this.getDataStudy(),
    _getDataStudyQC: () => this.getDataStudyQC(),
    _getWLList: () => this.getWLList(),
    _insertWindowLevel: data => this.insertWindowLevel(data),
    _getApiURL: () => this.getApiURL(),
  };

  constructor() {
    super(UserAuthenticationService.EVENTS);
    this.serviceImplementation = {
      ...this.serviceImplementation,
    };

    // Initialize axios headers if token exists
    if (this.accessToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${this.accessToken}`;
      // Automatically validate token on service creation if it exists
      // this.validateToken().catch(() => {
      //   this.handleUnauthenticated();
      // });
      this.getWindowLevel();
    }
  }

  private async validateToken() {
    const accessToken = this.accessToken;
    if (!accessToken) {
      this.handleUnauthenticated();
      return;
    }

    try {
      const response = await axios.post(
        `${this.apiBaseUrl}/auth/validate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        this.userInfo = response.data;
        this.accessToken = accessToken;
        this.isAuthenticated = true;
        // localStorage.setItem('accessToken', accessToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        this._broadcastEvent(UserAuthenticationService.EVENTS.USER_AUTHENTICATED, this.userInfo);
        return this.userInfo;
      }
    } catch (error) {
      this.handleUnauthenticated();
      throw error;
    }
  }

  private getWindowLevel = async () => {
    const response = await axios.get(`${this.apiBaseUrl}/custom-window-level`, {
      params: {
        page: 1,
        size: 100,
        force: true,
      },
    });
    const getData = response.data.data;
    // ✅ Mapping customMWL agar strukturnya sama seperti defaultPresets
    const mappedCustomMWL = getData.map(item => ({
      id: item.ID.toString(),
      description: item.Description,
      window: item.Width.toString(), // jika defaultPresets pakai string
      level: item.Level.toString(), // sama
      createdby: item.CreatedBy.toString(),
    }));
    this.CWLList = mappedCustomMWL;
    return mappedCustomMWL;

    // return [
    //   { description: 'Empty1', window: '125', level: '125' },
    //   { description: 'Empty2', window: '126', level: '126' },
    //   { description: 'Empty3', window: '127', level: '127' },
    //   { description: 'Empty4', window: '128', level: '128' },
    // ];
  };
  public getStudy = async (studyInstanceUID: string) => {
    try {
      const response = await axios.get(`${this.apiBaseUrl}/studies`, {
        params: {
          page: 1,
          size: 1,
          studyInstanceUID,
        },
      });
      const getData = response.data.data[0];
      this.dataStudy = getData;
      return getData;
    } catch (error: any) {
      return null;
    }
  };

  private insertWindowLevel = async data => {
    // console.warn('masuk');
    const response = await axios.post(`${this.apiBaseUrl}/custom-window-level`, data);
    if (response.status === 201) {
      await this.getWindowLevel();
    }
    return response;
  };

  public getWLList() {
    return this.CWLList;
  }

  public getDataStudy() {
    return this.dataStudy;
  }
  public getDataStudyQC() {
    return this.dataStudyQC;
  }

  public getState() {
    return this.serviceImplementation._getState();
  }

  public setUser(user) {
    return this.serviceImplementation._setUser(user);
  }
  public setStudyQC(study) {
    this.dataStudyQC.push(study);
  }

  public getUser() {
    // return this.serviceImplementation._getUser();
    return this.userInfo;
  }

  public getApiURL() {
    // return this.serviceImplementation._getUser();
    return this.apiBaseUrl;
  }

  public getAuthorizationHeader() {
    return this.serviceImplementation._getAuthorizationHeader();
  }

  public handleUnauthenticated() {
    return this.serviceImplementation._handleUnauthenticated();
  }

  public reset() {
    return this.serviceImplementation._reset();
  }

  public set(state) {
    return this.serviceImplementation._set(state);
  }

  public setServiceImplementation({
    getState: getStateImplementation,
    setUser: setUserImplementation,
    getUser: getUserImplementation,
    getApiURL: getApiURLImplementation,
    getAuthorizationHeader: getAuthorizationHeaderImplementation,
    handleUnauthenticated: handleUnauthenticatedImplementation,
    reset: resetImplementation,
    set: setImplementation,
    validateToken: validateTokenImplementation,
    getWindowLevel: getWindowLevelImplementation,
    getStudy: getStudyImplementation,
    getDataStudy: getDataStudyImplementation,
    getWLLIst: getWLListImplementation,
    insertWindowLevel: getInsertWindowLevelImplementation,
  }) {
    if (getStateImplementation) {
      this.serviceImplementation._getState = getStateImplementation;
    }
    if (setUserImplementation) {
      this.serviceImplementation._setUser = setUserImplementation;
    }
    if (getUserImplementation) {
      this.serviceImplementation._getUser = getUserImplementation;
    }
    if (getApiURLImplementation) {
      this.serviceImplementation._getApiURL = getApiURLImplementation;
    }
    if (getAuthorizationHeaderImplementation) {
      this.serviceImplementation._getAuthorizationHeader = getAuthorizationHeaderImplementation;
    }
    if (handleUnauthenticatedImplementation) {
      this.serviceImplementation._handleUnauthenticated = handleUnauthenticatedImplementation;
    }
    if (resetImplementation) {
      this.serviceImplementation._reset = resetImplementation;
    }
    if (setImplementation) {
      this.serviceImplementation._set = setImplementation;
    }
    // if (validateTokenImplementation) {
    //   this.serviceImplementation._validateToken = validateTokenImplementation;
    // }
    if (getWindowLevelImplementation) {
      this.serviceImplementation._getWindowLevel = getWindowLevelImplementation;
    }
    if (getStudyImplementation) {
      this.serviceImplementation._getStudy = getStudyImplementation;
    }
    if (getDataStudyImplementation) {
      this.serviceImplementation._getDataStudy = getDataStudyImplementation;
    }
    if (getWLListImplementation) {
      this.serviceImplementation._getWLList = getWLListImplementation;
    }
    if (getInsertWindowLevelImplementation) {
      this.serviceImplementation._insertWindowLevel = getInsertWindowLevelImplementation;
    }
  }
}

export default UserAuthenticationService;
